import { subDays } from 'date-fns';

import { startOfDayInMilliseconds, startOfDayInUTC } from '@utils/kpi-utils/date';

import { IChart } from '@interfaces/kpi/kpiCommon';

import { HALF_YEAR_DATE_INTERVAL } from '@constants/KPI/kpi-common';

export const getStartChartsDates = (charts: Array<IChart>): number[] => {
	return charts.reduce<number[]>((acc, chart) => {
		const firstDatesInChart = chart.lines.map(line => line.points[0].x);

		return [...acc, ...firstDatesInChart];
	}, []);
};

export const getIsKpiRelateExpired = ({
	today,
	chartDates,
}: {
	today: Date;
	chartDates: number[];
}): boolean => {
	const localStartOfDay = startOfDayInMilliseconds(today);
	const minAvailableDate = subDays(localStartOfDay, HALF_YEAR_DATE_INTERVAL);
	const minAvailableDateInUTC = startOfDayInUTC(minAvailableDate);

	return chartDates.some(date => date < minAvailableDateInUTC);
};

export const clearKPIRelate = ({
	compareCharts,
	correlateCharts,
	clearCompareCharts,
	clearCorrelateCharts,
}: {
	compareCharts: Array<IChart>;
	correlateCharts: Array<IChart>;
	clearCompareCharts: () => void;
	clearCorrelateCharts: () => void;
}): void => {
	const today = new Date();

	if (compareCharts.length) {
		const startChartsDates = getStartChartsDates(compareCharts);
		const shouldClearCompare = getIsKpiRelateExpired({
			today,
			chartDates: startChartsDates,
		});

		if (shouldClearCompare) clearCompareCharts();
	}
	if (correlateCharts.length) {
		const startChartsDates = getStartChartsDates(correlateCharts);
		const shouldClearCorrelate = getIsKpiRelateExpired({
			today,
			chartDates: startChartsDates,
		});

		if (shouldClearCorrelate) clearCorrelateCharts();
	}
};
